import { parseData, post } from './common';
import { responseHandler } from '../api/api';
const deleteCertifyAPIKey = (companyID, apiPartner_PK) => {
    return post('/InternalAPI/APIConfig.asmx/DeleteCertifyAPIKey', {
        CompanyID: companyID,
        APIPartner_PK: apiPartner_PK
    }).then(parseData);
};
const generateCertifyAPISecret = (companyID, apiPartner_PK) => {
    return post('/InternalAPI/APIConfig.asmx/GenerateCertifyAPISecret', {
        CompanyID: companyID,
        APIPartner_PK: apiPartner_PK
    })
        .then(parseData)
        .then(responseHandler);
};
const generateCertifyAPIKey = (companyID) => {
    return post('/InternalAPI/APIConfig.asmx/GenerateCertifyAPIKey', {
        CompanyID: companyID
    })
        .then(parseData)
        .then(responseHandler);
};
const changeInternalCred = (companyID, apiPartner_PK) => {
    return post('/InternalAPI/APIConfig.asmx/ChangeInternalCred', {
        CompanyID: companyID,
        APIPartner_PK: apiPartner_PK
    }).then(parseData);
};
const updateAPIName = (newName, apiPartner_PK) => {
    return post('/InternalAPI/APIConfig.asmx/UpdateAPIName', {
        Name: newName,
        APIPartner_PK: apiPartner_PK
    }).then(parseData);
};
export { deleteCertifyAPIKey, generateCertifyAPISecret, generateCertifyAPIKey, changeInternalCred, updateAPIName };
